import React, { useRef, useState } from "react";
import * as Fa from "react-icons/fa";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { toast } from "react-toastify";
import { fetchData } from "../../../Services/GlobalService";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import { downloadExcel } from "../../../Services/GlobalFunction/DownLoadExcel";
import Loader from "../../../Components/Loader";
import { AxiosExcel } from "../../../API/Axios";

/* ── Types ── */
const segmentOptions = [
  { label: "B2C",          value: "B2C"  },
  { label: "Industrial DB", value: "IDB"  },
];

const FORMAT_LIST = [
  { label: "xlsx", value: "xlsx" },
  { label: "csv",  value: "csv"  },
];

const VolumeDefinitionDistribution: React.FC = () => {
  const UserId    = localStorage.getItem("UserId")?.toString();
  const getformat = GetDateFormat();

  const BaseUrl = "/DBScoreCard/VolumeDefination";
  const Endpoint = {
    ExportFile: "ExportVolumeDefinationData",
    UploadFile: "UploadVolumeDefinationData",
  };

  const fileUploadRef = useRef<FileUpload>(null);

  /* ── State ── */
  const [segment,         setSegment]         = useState<typeof segmentOptions[number]["value"]>("B2C");
  const [templateFormat,  setTemplateFormat]  = useState<string>("xlsx");
  const [loader,          setLoader]          = useState<boolean>(false);
  const [loading,         setLoading]         = useState<boolean>(false);
  const [errorxlsbtn,     setErrorxlsbtn]     = useState<boolean>(false);
  const [errorxlsData,    setErrorxlsData]    = useState<any[]>([]);

  /* ── Download Template ── */
  const handleDownloadTemplate = () => {
    const headers = [{ Year: null, QTR: null, "Volume (Ltr)": null }];
    downloadExcel(headers, `Volume_Definition_Template_${getformat}.${templateFormat}`);
  };

  /* ── Export ── */
  const handleDownloadFile = async () => {
    setLoading(true);
    try {
      const res = await fetchData(BaseUrl, Endpoint.ExportFile, `Type=${segment}`);
      if (res?.Data?.length > 0) {
        downloadExcel(res.Data, `Volume_Definition_${getformat}.xlsx`);
      } else {
        toast.warn("No data found.");
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Failed to download file");
    } finally {
      setLoading(false);
    }
  };

  /* ── File Upload ── */
  const handleFileUpload = async (event: any) => {
    setLoader(true);
    try {
      const file = event.files[0];
      const formData = new FormData();
      formData.append("PvcUserid",   UserId ?? "");
      formData.append("Type",        segment);
      formData.append("FileContent", file);

      const response = await AxiosExcel.post(
        `${BaseUrl}/${Endpoint.UploadFile}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const res = response.data;
      if (res.Status === "Success") {
        toast.success(res.Message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status === "ErrorFR") {
        toast.warn(res.message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status === "Error") {
        toast.warn(res.message);
        setErrorxlsbtn(true);
        setErrorxlsData(res.Data);
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.message ?? "Upload failed");
      fileUploadRef.current?.clear();
      setErrorxlsbtn(false);
    } finally {
      setLoader(false);
    }
  };

  if (loader) return <Loader />;

  return (
    <main>
      <div className="col-12 mb-5">

        {/* ── Breadcrumb ── */}
        <div className="col-lg-12 col-md-12 col-sm-12">
          <nav aria-label="breadcrumb" className="drop-in">
            <ol className="breadcrumb mx-0">
              <li className="breadcrumb-item bold">DB SIP</li>
              <li className="breadcrumb-item active" aria-current="page">
                Volume Definition - Distribution
              </li>
            </ol>
          </nav>
        </div>

        {/* ── Page title + action buttons ── */}
        <div className="row">
                 <div className="col-lg-4 col-md-12 col-sm-12">
                   <h3 className="py-2">Volume Definition - Distribution</h3>
                 </div>
                 <div className="col-lg-8 col-md-12 col-sm-12">
                   <div className="text-end">
                     <div className="d-inline-flex">
                       <Dropdown
                         value={templateFormat}
                         onChange={(e) => setTemplateFormat(e.value)}
                         options={FORMAT_LIST}
                         optionLabel="label"
                         style={{
                           width: 100,
                           borderRadius: "0 6px 6px 0",
                           border: "1px solid #ced4da",
                           borderLeft: "none",
                           height: "100%",
                         }}
                       />
                     </div>
                     <button
                       type="button"
                       className="btn anime-secondary-btn mx-2"
                       onClick={handleDownloadTemplate}
                     >
                       Download Template <Fa.FaDownload className="ms-2" />
                     </button>
                    <button
                type="button"
                title="Export"
                className="btn anime-btn"
                onClick={handleDownloadFile}
                disabled={loading}
              >
                {loading ? (
                  <>
                    Exporting...{" "}
                    <span className="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true" />
                  </>
                ) : (
                  <>Export <Fa.FaFileExport className="ms-2" /></>
                )}
              </button>
                   </div>
                 </div>
               </div>

        <section className="sales-box">
            <div className="row">
              {/* Segment radio buttons */}
              <div className="col-lg-3 col-md-6 col-sm-12">
                  <label className="form-label">Segment</label>
                  <div className="d-flex flex-wrap gap-3 mt-1">
                    {segmentOptions.map((s) => (
                      <div key={s.value} className="d-inline-flex align-items-center">
                        <RadioButton
                          inputId={`seg-${s.value}`}
                          name="segment"
                          value={s.value}
                          onChange={(e) => setSegment(e.value)}
                          checked={segment === s.value}
                        />
                        <label htmlFor={`seg-${s.value}`} className="form-label ms-2 mb-0">
                          {s.label}
                        </label>
                      </div>
                    ))}
                  </div>
              </div>
          </div>

          {/* ── Upload section ── */}
          <div className="row d-flex justify-content-end align-items-end mt-3">
            <div className="col-lg-7 col-md-7 col-sm-12">
              <div className="UploadSection clearfix">
                <div className="conText">
                  <Fa.FaInfoCircle className="icon" /> Select an Excel or CSV File to upload
                </div>
                <FileUpload
                  ref={fileUploadRef}
                  className="clearfix nTopMargin"
                  name="demo[]"
                  accept=".xlsx, .xls, .csv"
                  emptyTemplate={
                    <p className="m-0">Drag and drop files to here to upload.</p>
                  }
                  customUpload
                  uploadHandler={handleFileUpload}
                  onClear={() => setErrorxlsbtn(false)}
                  onRemove={() => setErrorxlsbtn(false)}
                />

                {/* Error Excel download button */}
                {errorxlsbtn && (
                  <button
                    type="button"
                    className="btn anime-red-btn mt-2"
                    onClick={() => downloadExcel(errorxlsData, "Volume_Definition_Upload_Error.xlsx")}
                  >
                    Error Excel File <Fa.FaDownload className="ms-2" />
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12">
              <div className="text-end">
                <img
                  src={require("../../../Assets/Images/File_Upload.png")}
                  className="File_Upload_Img drop-right"
                  alt="InnoRise"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default VolumeDefinitionDistribution;